class SignIn {
    constructor() {
        this.switchToForgotPassword();
        this.forgottenPasswordFormValidation();
        this.signInFormValidation();
        this.twoFaFormValidation();
    }
    switchToForgotPassword(){
        if(window.location.href.includes("forgotten_password")){
            $('#frm-signInForm-signInForm').hide();
            $('#frm-forgottenPasswordForm-forgottenPasswordForm').show();
            history.replaceState(null, "", location.href.split("#")[0]);
        }

        $('#forgotPasswordBtn').click(function(){
            $('#frm-signInForm-signInForm').fadeOut(200, function(){
                $('#frm-forgottenPasswordForm-forgottenPasswordForm').fadeIn(200);
            });
        });

        $('#backToSignInBtn').click(function(){
            $('#frm-forgottenPasswordForm-forgottenPasswordForm').fadeOut(200, function(){
                $('#frm-signInForm-signInForm').fadeIn(200);
            });
        });
    }
    showAlreadyExistingEmailModal(){
        Swal.fire({
            text: "Your email is already in use. Please log in and accept the invitation.",
            icon: "info",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
                confirmButton: "btn btn-primary"
            }
        });
    }
    twoFaHandle(){
        const form = document.querySelector('#frm-verifyTwoStepForm-verifyMFAForm');
        if(form){
            new MfaInputEvents(form);
        }
    }
    forgottenPasswordFormValidation(){
        let form = document.getElementById('frm-forgottenPasswordForm-forgottenPasswordForm');
        if(form){
            let submitButton = document.getElementById('forgotten_password_form_submit');

            let validator = FormValidation.formValidation(
                form,
                {
                    fields: {
                        'username': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                            }
                        }
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger(),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        // Validate fields when clicking the Submit button
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        })
                    }
                }
            );

            submitButton.addEventListener('click', function (e) {
                // Prevent default button action
                e.preventDefault();
                validator.validate().then(function(status) {
                    if (status === 'Valid') {
                        // Show loading indication
                        submitButton.setAttribute('data-kt-indicator', 'on');
                        // Disable button to avoid multiple click
                        submitButton.disabled = true;
                        grecaptcha.ready(function () {
                            grecaptcha.execute('6LeM1SIeAAAAAPtFxbwdxqZxpqSHYe71aXVaecFP', {action: 'subscribe_newsletter'}).then(function (token) {
                                let forgottenPasswordForm = $('#frm-forgottenPasswordForm-forgottenPasswordForm');
                                forgottenPasswordForm.prepend('<input type="hidden" name="tokenRecaptcha" value="' + token + '">');
                                forgottenPasswordForm.prepend('<input type="hidden" name="action" value="subscribe_newsletter">');
                                // Submit form
                                form.submit();
                            });
                        });
                    }
                });
            });
        }
    }
    signInFormValidation(initNetteExt = true){
        const form = document.getElementById('frm-signInForm-signInForm');
        const submitButton = document.getElementById('sign_in_form_submit');

        if(form){
           const fv =  FormValidation.formValidation(
                form,
                {
                    fields: {
                        'username': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                            }
                        },
                        'password': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                            }
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger(),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        //defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        })
                    }
                }
            );

           const submitForm = function () {
               fv.validate().then(function(status) {
                   if(status === 'Valid'){
                       // Show loading indication
                       submitButton.setAttribute('data-kt-indicator', 'on');
                       // Disable button to avoid multiple click
                       submitButton.disabled = true;

                       $('#frm-signInForm-signInForm').submit();
                   }
               });
           }

            submitButton.addEventListener('click', function (e) {
                // Prevent default button action
                e.preventDefault();
                submitForm();
            });

            form.addEventListener('keyup', function(event) {
                if (event.code === 'Enter' || event.keyCode === 13)
                {
                    event.preventDefault();
                    submitForm();
                }
            });

            const thisClass = this;
            if(initNetteExt){
                $.nette.ext('signInFormExt', {
                    success: function (payload, status, jqXHR, settings) {
                        let formID = settings.nette.form[0].attributes.id.value;
                        if(formID === 'frm-signInForm-signInForm'){
                            if(payload['logged']){
                                if(payload['expired_password']){
                                    thisClass.expirePasswordFormValidation();
                                }else{
                                    thisClass.twoFaFormValidation();
                                }
                            } else {
                                submitButton.setAttribute('data-kt-indicator', 'off');
                                submitButton.disabled = false;
                            }
                        }
                    }
                });
            }

        }
    }

    twoFaFormValidation(initNetteExt = true){

        Inputmask("", {
            "numericInput": true
        }).mask(".two-fa-input");

        const form          = document.getElementById('frm-verifyTwoStepForm-verifyMFAForm');
        const submitButton  = document.getElementById('two-step-form-submit');
        const thisClass     = this;
        this.twoFaHandle();

        if(form){
            const fv    = new MfaInputValidator('frm-verifyTwoStepForm-verifyMFAForm').enableMFAFormValidation();
            const submitForm = function () {
                fv.validate().then(function(status) {
                    if(status === 'Valid'){
                        submitButton.setAttribute('data-kt-indicator', 'on');
                        submitButton.disabled = true;
                        $('#frm-verifyTwoStepForm-verifyMFAForm').submit();
                    }
                });
            }
            submitButton.addEventListener('click', function (e) {
                e.preventDefault();
                submitForm();
            });
            form.addEventListener('keyup', function(event) {
                if (event.code === 'Enter' || event.keyCode === 13)
                {
                    event.preventDefault();
                    submitForm();
                }
            });
            if(initNetteExt){
                $.nette.ext('twoStepFormExt', {
                    success: function (payload, status, jqXHR, settings) {
                        let formID = settings.nette.form[0].attributes.id.value;
                        if(formID === 'frm-verifyTwoStepForm-verifyMFAForm'){
                            if(!payload['passed']){
                                submitButton.setAttribute('data-kt-indicator', 'off');
                                submitButton.disabled = false;
                                thisClass.twoFaFormValidation(false);
                            }
                        }
                    }
                });
            }
        }
    }
    expirePasswordFormValidation(initNetteExt = true){
        new KTPasswordMeter.createInstances();
        let form = document.getElementById('frm-expirePasswordForm-expiredPasswordForm');
        if(form){
            const submitButton = document.getElementById('expire_password_form_submit');
            let passwordMeter = KTPasswordMeter.getInstance(form.querySelector('[data-kt-password-meter="true"]'));
            // Password input validation
            const validatePassword = function() {
                return (passwordMeter.getScore() === 100);
            };

            const fv = FormValidation.formValidation(
                form,
                {
                    fields: {
                        'password': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                stringLength: {
                                    max: 45,
                                    message: 'Password has to be between 8 and 45 characters long',
                                },
                                regexp: {
                                    regexp: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~`!#@$%\^&*+=\-\[\]\\\';,\/{}|\\":<>\?()§_´¨.])[A-Za-z\d[~`!#@$%\^&*+=\-\[\]\\\';,\/{}|\\":<>\?()§_´¨.]{8,45}$/,
                                    message: '',
                                },
                                callback: {
                                    message: 'Please enter valid password',
                                    callback: function() {
                                        return validatePassword();
                                    }
                                }
                            }
                        }
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger(),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        //defaultSubmit: new FormValidation.plugins.DefaultSubmit()
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.form-validation-marker',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        }),
                        icon: new FormValidation.plugins.Icon({
                            valid: 'fa fa-check',
                            invalid: 'fa fa-times',
                            validating: 'fa fa-refresh',
                        }),
                    }
                }
            ).on('core.element.validated', function(e) {
                if(e.element.attributes.name.value === 'password'){
                    // Get the icon plugin instance
                    const iconPlugin = validator.getPlugin('icon');
                    const iconElement = iconPlugin && iconPlugin.icons.has(e.element) ? iconPlugin.icons.get(e.element) : null;
                    // Hide the icon
                    iconElement && (iconElement.style.display = 'none');
                }
            });
            const submitForm = function () {
                fv.validate().then(function(status) {
                    if(status === 'Valid'){
                        submitButton.setAttribute('data-kt-indicator', 'on');
                        submitButton.disabled = true;
                        $('#frm-expirePasswordForm-expiredPasswordForm').submit();
                    }
                });
            };
            submitButton.addEventListener('click', function (e) {
                e.preventDefault();
                submitForm();
            });
            form.addEventListener('keyup', function(event) {
                if (event.code === 'Enter' || event.keyCode === 13)
                {
                    event.preventDefault();
                    submitForm();
                }
            });
            if(initNetteExt){
                const thisClass = this;
                $.nette.ext('expirePasswordFormExt', {
                    success: function (payload, status, jqXHR, settings) {
                        let formID = settings.nette.form[0].attributes.id.value;
                        if(formID === 'frm-expirePasswordForm-expiredPasswordForm'){
                            if(payload['passed']){
                                thisClass.twoFaFormValidation();
                            }
                        }
                    }
                });
            }
        }
    }
}
window.SignIn = SignIn;